import { makeStyles, tokens } from '@fluentui/react-components';

export const useCenteredPageLayoutStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    height: '100vh',
    backgroundColor: tokens.colorPaletteBlueBackground2,
  },
});
